import { LabDto } from "../../../../../customer-experience/src/lib/ShiOneClient";
import { Box, CardHeader, Typography, useTheme } from "@mui/material";
import React from "react";
import { LabPracticeTitleData } from "./LabCards";
import { PartnerNames } from "./PartnerNames";

interface LabCardHeaderProps {
  lab: LabDto;
  practice?: string;
  labPracticeTitleData: LabPracticeTitleData[];
}
const LabCardHeader: React.FC<LabCardHeaderProps> = ({
  lab,
  practice,
  labPracticeTitleData,
}) => {
  const theme = useTheme();
  const practiceHeaderColor = practice
    ? labPracticeTitleData.find((item) => item.title === practice.trim())?.color
    : undefined;

  return (
    <CardHeader
      key={`${lab.id}-${practice}`}
      title={
        <Box
          key={`${lab.id}-${practice}`}
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          {practice ? (
            <Typography
              color={practiceHeaderColor}
              variant="caption"
              sx={{
                display: "flex",
                fontStyle: "italic",
              }}
            >
              {practice}
            </Typography>
          ) : (
            <Box />
          )}

          <PartnerNames partners={lab.partners} />
        </Box>
      }
      subheader={
        <Typography
          key={`${lab.id}-${practice}`}
          color={theme.palette.text.primary}
          component="div"
          variant="body2"
          sx={{
            marginTop: 1,
            minHeight: 40,
            fontSize: "15px",
          }}
        >
          {lab.productName}
        </Typography>
      }
    />
  );
};

export default LabCardHeader;
